'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

// Hydration errors would result in a client-side reload of the DOM,
// with the Squeezly/Spotler personalizations being thrown away.
// This function kicks off a reload of the personalizations.
export const SpotlerReload = () => {
  const pathname = usePathname()

  useEffect(() => {
    window._sqzl = window._sqzl || []
    window._sqzl.push({ event: 'ReloadPersonalization' })
  }, [pathname])

  return null
}
